export enum TileColor {
  None = 0,
  Red = 1,
  Green = 2,
  Blue = 3,
  Pink = 4,
  Yellow = 5,
  Grey = 6,
  White = 7,
  Navy = 8,
  Purple = 9,
}

export type TileColorMap<T> = Record<TileColor, T>;

export const TILE_COLORS = Object.values(TileColor).filter(
  (key) => typeof key === 'number' && key !== TileColor.None,
) as TileColor[];

export const TILE_COLOR_TEXTURE_MAP: TileColorMap<string> = {
  [TileColor.None]: 'tile_empty',
  [TileColor.Red]: `tile_red`,
  [TileColor.Green]: `tile_green`,
  [TileColor.Blue]: `tile_blue`,
  [TileColor.Pink]: `tile_pink`,
  [TileColor.Yellow]: `tile_yellow`,
  [TileColor.Grey]: `tile_grey`,
  [TileColor.White]: `tile_white`,
  [TileColor.Navy]: `tile_navy`,
  [TileColor.Purple]: `tile_purple`,
};

export const TILE_COLOR_FLIP_TEXTURES_MAP: TileColorMap<{
  vertical: string[];
  diagonalBottom: string[];
  diagonalTop: string[];
}> = {
  [TileColor.Blue]: {
    vertical: ['Blue_Vertical_Flip_1', 'Blue_Vertical_Flip_2', 'Blue_Vertical_Flip_3', 'Blue_Vertical_Flip_4'],
    diagonalTop: [
      'Blue_Diagonal_Top_Flip_1',
      'Blue_Diagonal_Top_Flip_2',
      'Blue_Diagonal_Top_Flip_3',
      'Blue_Diagonal_Top_Flip_4',
    ],
    diagonalBottom: [
      'Blue_Diagonal_Bottom_Flip_1',
      'Blue_Diagonal_Bottom_Flip_2',
      'Blue_Diagonal_Bottom_Flip_3',
      'Blue_Diagonal_Bottom_Flip_4',
    ],
  },
  [TileColor.Red]: {
    vertical: ['Red_Vertical_Flip_1', 'Red_Vertical_Flip_2', 'Red_Vertical_Flip_3', 'Red_Vertical_Flip_4'],
    diagonalTop: [
      'Red_Diagonal_Top_Flip_1',
      'Red_Diagonal_Top_Flip_2',
      'Red_Diagonal_Top_Flip_3',
      'Red_Diagonal_Top_Flip_4',
    ],
    diagonalBottom: [
      'Red_Diagonal_Bottom_Flip_1',
      'Red_Diagonal_Bottom_Flip_2',
      'Red_Diagonal_Bottom_Flip_3',
      'Red_Diagonal_Bottom_Flip_4',
    ],
  },
  [TileColor.Green]: {
    vertical: ['Green_Vertical_Flip_1', 'Green_Vertical_Flip_2', 'Green_Vertical_Flip_3', 'Green_Vertical_Flip_4'],
    diagonalTop: [
      'Green_Diagonal_Top_Flip_1',
      'Green_Diagonal_Top_Flip_2',
      'Green_Diagonal_Top_Flip_3',
      'Green_Diagonal_Top_Flip_4',
    ],
    diagonalBottom: [
      'Green_Diagonal_Bottom_Flip_1',
      'Green_Diagonal_Bottom_Flip_2',
      'Green_Diagonal_Bottom_Flip_3',
      'Green_Diagonal_Bottom_Flip_4',
    ],
  },

  [TileColor.Grey]: {
    vertical: ['Grey_Vertical_Flip_1', 'Grey_Vertical_Flip_2', 'Grey_Vertical_Flip_3', 'Grey_Vertical_Flip_4'],
    diagonalTop: [
      'Grey_Diagonal_Top_Flip_1',
      'Grey_Diagonal_Top_Flip_2',
      'Grey_Diagonal_Top_Flip_3',
      'Grey_Diagonal_Top_Flip_4',
    ],
    diagonalBottom: [
      'Grey_Diagonal_Bottom_Flip_1',
      'Grey_Diagonal_Bottom_Flip_2',
      'Grey_Diagonal_Bottom_Flip_3',
      'Grey_Diagonal_Bottom_Flip_4',
    ],
  },

  [TileColor.Pink]: {
    vertical: ['Pink_Vertical_Flip_1', 'Pink_Vertical_Flip_2', 'Pink_Vertical_Flip_3', 'Pink_Vertical_Flip_4'],
    diagonalTop: [
      'Pink_Diagonal_Top_Flip_1',
      'Pink_Diagonal_Top_Flip_2',
      'Pink_Diagonal_Top_Flip_3',
      'Pink_Diagonal_Top_Flip_4',
    ],
    diagonalBottom: [
      'Pink_Diagonal_Bottom_Flip_1',
      'Pink_Diagonal_Bottom_Flip_2',
      'Pink_Diagonal_Bottom_Flip_3',
      'Pink_Diagonal_Bottom_Flip_4',
    ],
  },

  [TileColor.White]: {
    vertical: ['White_Vertical_Flip_1', 'White_Vertical_Flip_2', 'White_Vertical_Flip_3', 'White_Vertical_Flip_4'],
    diagonalTop: [
      'White_Diagonal_Top_Flip_1',
      'White_Diagonal_Top_Flip_2',
      'White_Diagonal_Top_Flip_3',
      'White_Diagonal_Top_Flip_4',
    ],
    diagonalBottom: [
      'White_Diagonal_Bottom_Flip_1',
      'White_Diagonal_Bottom_Flip_2',
      'White_Diagonal_Bottom_Flip_3',
      'White_Diagonal_Bottom_Flip_4',
    ],
  },

  [TileColor.Yellow]: {
    vertical: ['Yellow_Vertical_Flip_1', 'Yellow_Vertical_Flip_2', 'Yellow_Vertical_Flip_3', 'Yellow_Vertical_Flip_4'],
    diagonalTop: [
      'Yellow_Diagonal_Top_Flip_1',
      'Yellow_Diagonal_Top_Flip_2',
      'Yellow_Diagonal_Top_Flip_3',
      'Yellow_Diagonal_Top_Flip_4',
    ],
    diagonalBottom: [
      'Yellow_Diagonal_Bottom_Flip_1',
      'Yellow_Diagonal_Bottom_Flip_2',
      'Yellow_Diagonal_Bottom_Flip_3',
      'Yellow_Diagonal_Bottom_Flip_4',
    ],
  },

  [TileColor.Navy]: {
    vertical: ['Navy_Vertical_Flip_1', 'Navy_Vertical_Flip_2', 'Navy_Vertical_Flip_3', 'Navy_Vertical_Flip_4'],
    diagonalTop: [
      'Navy_Diagonal_Top_Flip_1',
      'Navy_Diagonal_Top_Flip_2',
      'Navy_Diagonal_Top_Flip_3',
      'Navy_Diagonal_Top_Flip_4',
    ],
    diagonalBottom: [
      'Navy_Diagonal_Bottom_Flip_1',
      'Navy_Diagonal_Bottom_Flip_2',
      'Navy_Diagonal_Bottom_Flip_3',
      'Navy_Diagonal_Bottom_Flip_4',
    ],
  },

  [TileColor.Purple]: {
    vertical: ['Purple_Vertical_Flip_1', 'Purple_Vertical_Flip_2', 'Purple_Vertical_Flip_3', 'Purple_Vertical_Flip_4'],
    diagonalTop: [
      'Purple_Diagonal_Top_Flip_1',
      'Purple_Diagonal_Top_Flip_2',
      'Purple_Diagonal_Top_Flip_3',
      'Purple_Diagonal_Top_Flip_4',
    ],
    diagonalBottom: [
      'Purple_Diagonal_Bottom_Flip_1',
      'Purple_Diagonal_Bottom_Flip_2',
      'Purple_Diagonal_Bottom_Flip_3',
      'Purple_Diagonal_Bottom_Flip_4',
    ],
  },

  [TileColor.None]: {
    vertical: [],
    diagonalTop: [],
    diagonalBottom: [],
  },
};
